module.exports = __webpack_public_path__ + "static/media/arrow-up.16f3998a.svg";